import { useQuery } from "@tanstack/react-query";
import { api, ApiError } from "../api/client";
import type { AuthUser } from "./useAuth";

export function useCurrentSystem() {
  return useQuery<AuthUser["current_system"]>({
    queryKey: ["auth", "me", "current-system"],
    queryFn: async () => {
      try {
        const me = await api<AuthUser>("/auth/me");
        return me.current_system;
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    refetchInterval: 5000,
    refetchOnWindowFocus: true,
    retry: false,
  });
}
